const Layout = ({ children }) => {
  return <main className="tw1-relative" style={{ height: '95vh', overflowY: 'scroll' }}>{children}</main>;
};

export default Layout;
